import { Reservation } from '@/models/reservation';
import { Image } from '@/models/image';
import { Treatment } from '@/models/treatment';
import { Deserializable } from '@common/interfaces/deserializable';

export interface UserTreatmentInput {
  id: number;
  menu_id: number;
}

export class UserTreatment implements Deserializable<UserTreatment>, UserTreatmentInput {
  id!: number;
  menu_id: number;
  state: string;
  menu?: Treatment;
  reservations?: Reservation[];
  images?: Image[];

  get onlyOneReservation() {
    return this.reservations ? this.reservations[0] : null;
  }

  deserialize(input: Partial<UserTreatmentInput>): UserTreatment {
    Object.assign(this, input);
    return this;
  }
}
